import { api } from '@/services/api'

export async function getTestTopics(): Promise<string[]> {
  const { data } = await api.get('/fluency-test/topics')
  return data
}
